import axios from 'axios';
import Setting from '@/setting';
import util from '@/libs/util';

import { Message } from 'element-ui';

// 记录和显示错误
function errorLog(err) {
}

// 创建一个 axios 实例
const service = axios.create({
    baseURL: Setting.apiBaseURL,
    timeout: 10000 // 请求超时时间
});

axios.defaults.withCredentials = true;// 携带cookie

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        // startLoading()
    }
    needLoadingRequestCount++
}
export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        // endLoading()
    }
}

// 请求拦截器
service.interceptors.request.use(
    async config => {
        config.baseURL = Setting.apiBaseURL
        let token = localStorage.token
        if (token) {
            config.headers['Access-Token'] = token;
        }
        // 开启loading
        showFullScreenLoading();
        return config;
    },
    error => {
        // 发送失败
        Promise.reject(error);
    }
);
// 响应拦截器
service.interceptors.response.use(
    response => {
        // 获取服务器类型
        if (!sessionStorage.getItem("SERVER_TYPE")) {
            sessionStorage.setItem("SERVER_TYPE", response.headers['server']);
        }
        // 关闭loading
        tryHideFullScreenLoading();
        const code = response.data.code;
        switch (code) {
            case 1:
                // [ 示例 ] code === 0 代表没有错误
                return response.data;
            case -2:
                return Promise.reject(response.data || { msg: '未知错误' });
            // [ 示例 ] 其它和后台约定的 code
            // errorCreate(response.data.msg);
            // break;
            case -1:
                window.router.replace('/login');
                break;
            case 0:
                Message.error(response.data.msg);
                break;
            default:
                // 不是正确的 code
                return response.data;
                break;
        }
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = '请求错误';
                    break;
                case 401:
                    error.message = '未授权，请登录';
                    break;
                case 403:
                    error.message = '拒绝访问';
                    break;
                case 404:
                    error.message = `请求地址出错: ${error.response.config.url}`;
                    break;
                case 408:
                    error.message = '请求超时';
                    break;
                case 500:
                    error.message = '服务器内部错误';
                    break;
                case 501:
                    error.message = '服务未实现';
                    break;
                case 502:
                    error.message = '网关错误';
                    break;
                case 503:
                    error.message = '服务不可用';
                    break;
                case 504:
                    error.message = '网关超时';
                    break;
                case 505:
                    error.message = 'HTTP版本不受支持';
                    break;
                default:
                    break;
            }
        }
        errorLog(error);
    }
);

export default service;
